import React from 'react';
import { Box, BoxExtendedProps } from '@common-fe/common-fe';

const ProofOfNecessityTab: React.FC<BoxExtendedProps> = ({ ...props }) => {
  return <Box {...props}>ReceiptsTab</Box>;
};

export default ProofOfNecessityTab;
